import { render, staticRenderFns } from "./heroBlock.vue?vue&type=template&id=58df2ba9&scoped=true"
import script from "./heroBlock.vue?vue&type=script&lang=js"
export * from "./heroBlock.vue?vue&type=script&lang=js"
import style0 from "./heroBlock.vue?vue&type=style&index=0&id=58df2ba9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58df2ba9",
  null
  
)

export default component.exports